import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { IBranch } from 'app/shared/Domains/branch';
import { IMemberPaymentOnRegistration } from 'app/shared/Domains/paymentOnRegistration';
import { AppServiceManager } from "common/services/appServiceManager";
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IMember } from 'app/shared/Domains/member';
import { AppUtils } from 'common/services/app.util';
import {
  computeBillingPeriodBounds,
  PackageDurationInput,
  parseLocalBillingDate,
  resolveMonthlyFeeDueDatePreview,
  toBillingDateString,
} from 'common/services/customer-fees-payload.util';
@Component({
  selector: 'app-feeCollection-signup',
  templateUrl: './feeCollection-signup.component.html',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClicky($event)" },
  styleUrls: ['./feeCollection-signup.component.css']
})
export class FeeCollectionSignupComponent implements OnInit {

  @Input() totalPackageFee: number;
  @Input() totalReceivedFee: number;
  @Input() totalTrainerFee: number;
  @Input() totalRegistrationPackageFee: number;
  @Input() feeInvoiceDialog: boolean;
  @Input() noofMonths: number;
  @Input() members: IMember[];
  @Input() packageFeeType: string;
  @Input() packageRegFeeType: string;
  @Input() packageName: string;
  @Input() packageType: string;
  @Input() joiningDate: Date;
  @Input() member_id: string;
  @Input() onlineMembers: string; 
  @Input() durationType: string; 
  @Output() addFund = new EventEmitter<any>();
  @Output() closeFeeCollectionDialog = new EventEmitter<any>();
  @ViewChild("totalFeePackage", { static: false }) totalFeePackageInput: ElementRef;
  enterSteps: any[];
  currentStep: any;
  paymentMode: any;
  registrationDiscount: number;
  branch: IBranch;
  monthlyDiscount: number;
  trainerDiscount: number;
  totalFee: number;
  months: number;
  expiryDate: Date;
  dueDate: string;
  labelMembers: string;
  labelMonths: string;
  label: string;
  displayMonthsMembers: number;
  packageFeeLabel: string;
  regFeeLabel: string;
  discountExceedsFee: boolean = false;
  discountExceedsRegistrationFee: boolean = false;
  trainerDiscountExceeds: boolean = false;
  paymentOnRegistration: IMemberPaymentOnRegistration;
  onlinePayment: IMemberPaymentOnRegistration;
  selectedMemberId: any;
  onlineButtonPressed = false;
  description: any;
  paymentOptions: any;
  selectedFileName: any;
  modifiedFileName: string;
  selectedFile: File;
  currentUser: any;
  currentUserData: any;
  feeReceiptImageUrl: any;
  monthlyFeeCalculationEquation: string;
  monthlyFeeCalculationEquationTotal: number;
  taxOnMonthlyFee: number;
  registrationFeeCalculationEquation: string;
  registrationFeeCalculationEquationTotal: number;
  taxOnRegistration: number;
  trainerFeeCalculationEquation: string;
  trainerFeeCalculationEquationTotal: number;
  taxOnTrainerFee: number;
  grandTotalCalculationEquation: string;
  grandTotalCalculationEquationTotal: number;
  payments: any[];
  taxRate: number;
  taxType: string;
  whatsAppCommunityLink: any;
  whatsAppCommunityLinkMessage: string;
  isDiscountFormulaReverse: boolean;
  totalMembers: number;
  /** Full monthly package fee before user edits (for partial-pay preview). */
  private fullMonthlyNetFee = 0;
  // packageDiscount:number = 0;
  // registrationDiscount:number;

  constructor(
    private LanguageService: LanguageService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    public config: Configuration
  ) { }

  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("FeesInvoiceComponent", label);
  }
  ngOnInit(): void {
    this.currentUser = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(this.currentUser);
    this.registrationDiscount = 0;
    this.trainerDiscount = 0;
    this.paymentOptions = [
      { label: 'Cash - Reception', value: 'Cash-Reception' },
    ];
    this.getBranchById();
    this.paymentMode = "Cash-Reception";
    console.log(this.durationType,this.noofMonths);
    this.monthlyDiscount = 0;
    this.expiryDate = new Date(this.joiningDate);
    this.labelMembers = "Member";
    this.labelMonths = "Month";
    this.label = this.labelMonths;
    this.displayMonthsMembers = this.noofMonths
    this.currentStep = 0;
    this.months = this.noofMonths;
    this.setFeeLabels();
    this.totalMembers = this.members?.length || 0
    if (this.packageRegFeeType == "whole package Registration fee") {
      //this.totalRegistrationPackageFee=Math.round(this.totalRegistrationPackageFee/this.totalMembers)
    }
    if (this.packageType.toLowerCase() == "person wise package") {
      this.totalRegistrationPackageFee = Math.round(this.totalRegistrationPackageFee / this.totalMembers)
      this.displayMonthsMembers = this.totalMembers;
      this.label = this.labelMembers;
    }
    if (this.packageFeeType == "whole package fee") {
      this.totalPackageFee = Math.round(this.totalPackageFee / this.totalMembers);
    }
    if (this.packageRegFeeType == "whole package Registration fee") {
      this.totalRegistrationPackageFee = Math.round(this.totalRegistrationPackageFee / this.totalMembers)
    }
    if (this.totalMembers > 1) {
      this.totalReceivedFee = (this.totalPackageFee) * this.totalMembers;
    }
    else {
      this.totalReceivedFee = this.totalPackageFee
    }
    this.fullMonthlyNetFee =
      (Number(this.totalPackageFee) || 0) *
      (this.totalMembers > 1 ? this.totalMembers : 1);
    this.updateNextDueDatePreview();
    this.totalFee = this.totalReceivedFee
    this.enterSteps = [
      "totalFeePackage",
      "receivedFeePackage",
      "registrationFeePackage",
      "trainerFeePackage",
      "feeSaveButton"
    ];

    this.compileFeeCalculationEquation();
    this.updateNextDueDatePreview();
  }

 private calculateTax(baseAmount: number, discount: number, texRate: any, texType: string, isDiscountFormulaReverse: boolean) {
    let taxableAmount = isDiscountFormulaReverse ? baseAmount : (baseAmount - discount);
    let tax = 0;
    if (baseAmount === discount && isDiscountFormulaReverse) {
       return { total: taxableAmount, tax: 0 };
    }
    if (texType === "WITH_TAX") {
      tax = parseFloat((taxableAmount * texRate / 100.0).toFixed(2));
      return { total: taxableAmount + tax, tax };
    }

    if (texType === "INCLUDING_TAX") {
      tax = parseFloat((taxableAmount * texRate / 100.0).toFixed(2));
      return { total: taxableAmount, tax };
    }

    return { total: taxableAmount, tax: 0 };
  }


  compileFeeCalculationEquation() {
  const texRate = this.taxRate;
  const texType = this.taxType;
  const isReverse = this.branch?.permissions?.isDiscountFormulaReverse || false;

  // Monthly fee calculation
  if (!(this.totalMembers > 1)) {
    const totalPackageFee = this.totalPackageFee;
    const result = this.calculateTax(totalPackageFee, this.monthlyDiscount, texRate, texType, isReverse);

    const effectiveTax = this.monthlyDiscount >= totalPackageFee ? 0 : result.tax;
    this.taxOnMonthlyFee = effectiveTax;    
    
    if (texType === "INCLUDING_TAX") {
        this.monthlyFeeCalculationEquationTotal = (totalPackageFee - this.monthlyDiscount)
        this.monthlyFeeCalculationEquation = `( ${this.totalPackageFee} - ${this.monthlyDiscount}(Discount) ) + ${result.tax}(Including-Tax) = ${this.totalPackageFee - this.monthlyDiscount}`;
    }else{
        this.monthlyFeeCalculationEquationTotal = (totalPackageFee - this.monthlyDiscount) + effectiveTax;
        this.monthlyFeeCalculationEquation = `( ${this.totalPackageFee} - ${this.monthlyDiscount}(Discount) ) + ${result.tax}(Tax) = ${this.totalPackageFee - this.monthlyDiscount + effectiveTax}`;
    }}

  if (this.totalMembers > 1) {
    const totalPackageFee = this.totalPackageFee * this.totalMembers;
    const result = this.calculateTax(totalPackageFee, this.monthlyDiscount, texRate, texType, isReverse);

    const effectiveTax = this.monthlyDiscount >= totalPackageFee ? 0 : result.tax;
    this.taxOnMonthlyFee = effectiveTax; 

    if (texType === "INCLUDING_TAX") {
        this.monthlyFeeCalculationEquationTotal = (totalPackageFee - this.monthlyDiscount)
        this.monthlyFeeCalculationEquation = `( ${this.totalPackageFee} * ${this.totalMembers}(Members) - ${this.monthlyDiscount}(Discount) ) + ${result.tax}(Including-Tax) = ${(this.totalPackageFee* this.totalMembers)- this.monthlyDiscount}`;
    }else{
        this.monthlyFeeCalculationEquationTotal = (totalPackageFee - this.monthlyDiscount) + effectiveTax;
        this.monthlyFeeCalculationEquation = `( ${this.totalPackageFee} * ${this.totalMembers}(Members) - ${this.monthlyDiscount}(Discount) ) + ${result.tax}(Tax) = ${ (this.totalPackageFee* this.totalMembers) - this.monthlyDiscount + effectiveTax}`;
    }}

  // Registration fee
  if (!(this.totalMembers > 1)) {
  const totalRegistration = this.totalRegistrationPackageFee
  const regResult = this.calculateTax(totalRegistration, this.registrationDiscount, texRate, texType, isReverse);

    const regEffectiveTax = this.registrationDiscount >= totalRegistration ? 0 : regResult.tax;
    this.taxOnRegistration = regEffectiveTax; 

  if (texType === "INCLUDING_TAX") {
      this.registrationFeeCalculationEquationTotal = (totalRegistration - this.registrationDiscount)
      this.registrationFeeCalculationEquation = `( ${this.totalRegistrationPackageFee} - ${this.registrationDiscount}(Discount) ) + ${regResult.tax}(Including-tax) = ${this.totalRegistrationPackageFee - this.registrationDiscount}`;
  }else{
      this.registrationFeeCalculationEquationTotal = (totalRegistration - this.registrationDiscount) + regEffectiveTax
      this.registrationFeeCalculationEquation = `( ${this.totalRegistrationPackageFee} - ${this.registrationDiscount}(Discount) ) + ${regResult.tax}(tax) = ${this.totalRegistrationPackageFee - this.registrationDiscount + regEffectiveTax}`;
  }}

  if (this.totalMembers > 1) {
  const totalRegistration = this.totalRegistrationPackageFee * this.totalMembers;
  const regResult = this.calculateTax(totalRegistration, this.registrationDiscount, texRate, texType, isReverse);

    const regEffectiveTax = this.registrationDiscount >= totalRegistration ? 0 : regResult.tax;
    this.taxOnRegistration = regEffectiveTax; 

  if (texType === "INCLUDING_TAX") {
      this.registrationFeeCalculationEquationTotal = (totalRegistration - this.registrationDiscount)
      this.registrationFeeCalculationEquation = `( ${this.totalRegistrationPackageFee} * ${this.totalMembers}(Members) - ${this.registrationDiscount}(Discount) ) + ${regResult.tax}(Including-tax) = ${(this.totalRegistrationPackageFee * this.totalMembers) - this.registrationDiscount}`;
  }else{
      this.registrationFeeCalculationEquationTotal = (totalRegistration - this.registrationDiscount) + regEffectiveTax
      this.registrationFeeCalculationEquation = `( ${this.totalRegistrationPackageFee} * ${this.totalMembers}(Members) - ${this.registrationDiscount}(Discount) ) + ${regResult.tax}(tax) = ${(this.totalRegistrationPackageFee * this.totalMembers) - this.registrationDiscount + regEffectiveTax}`;
  }}
  
  // Trainer Fee
  // if (this.totalTrainerFee != 0) {
  //   const totalTrainerFee = this.totalTrainerFee * this.totalMembers;
  //   const trainerResult = this.calculateTax(totalTrainerFee, this.trainerDiscount, texRate, texType, isReverse);

  //   this.taxOnTrainerFee = trainerResult.tax;
  //   this.trainerFeeCalculationEquationTotal = (this.totalTrainerFee - this.trainerDiscount) + trainerResult.tax
  //   this.trainerFeeCalculationEquation = `( ${this.totalTrainerFee} * ${this.totalMembers}(Members) - ${this.trainerDiscount}(Discount) ) + ${trainerResult.tax}(Tax) = ${(this.totalTrainerFee * this.totalMembers) - this.trainerDiscount + trainerResult.tax}`;
  // } else {
  //   this.taxOnTrainerFee = 0;
  //   this.trainerFeeCalculationEquationTotal = 0;
  // }

  // Grand total
  if (this.trainerFeeCalculationEquationTotal > 0) {
    this.grandTotalCalculationEquationTotal = Math.round(this.monthlyFeeCalculationEquationTotal + this.registrationFeeCalculationEquationTotal + this.trainerFeeCalculationEquationTotal);
    this.grandTotalCalculationEquation = `${this.monthlyFeeCalculationEquationTotal} + ${this.registrationFeeCalculationEquationTotal} + ${this.trainerFeeCalculationEquationTotal} = ${this.monthlyFeeCalculationEquationTotal + this.registrationFeeCalculationEquationTotal + this.trainerFeeCalculationEquationTotal}`;
  } else {
    this.grandTotalCalculationEquationTotal = Math.round(this.monthlyFeeCalculationEquationTotal + this.registrationFeeCalculationEquationTotal);
    this.grandTotalCalculationEquation = `${this.monthlyFeeCalculationEquationTotal} + ${this.registrationFeeCalculationEquationTotal} = ${this.monthlyFeeCalculationEquationTotal + this.registrationFeeCalculationEquationTotal}`;
  }
}

  getBranchById() {
    this.appServiceManager.get('branches/' + AuthService.getLoggedInBranch()).subscribe((res) => {
      if (res) {
        res.payments.forEach(payment => {
          const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
          if (!existingBank) {
            this.paymentOptions.push({
              label: `${payment.type} - ${payment.name}`,
              value: `${payment.type}-${payment.name}`
            });
          }
        });
        this.branch = res;
        this.whatsAppCommunityLink = res.whatsappCommunityInvitationLink;
        this.whatsAppCommunityLinkMessage = "\n\nWe also have a vibrant WhatsApp community where our members share tips, motivation, and support each other's fitness journeys. If you'd like to join this community, simply tap on this link\n" + this.whatsAppCommunityLink;
        let length;
        if (Array.isArray(this.branch.payments)) {
          length = this.branch.payments.length;
        }
        this.taxType = this.branch.payments[length - 1].taxSettings.taxCalculationType;
        this.taxRate = this.branch.payments[length - 1].taxSettings.taxRate;
        this.payments = res.payments;
        this.compileFeeCalculationEquation();
        this.updateNextDueDatePreview();
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  checkPackageDiscount() {
    let calPackageFee;
    if (this.noofMonths == 1 && this.totalMembers == 1) {
      calPackageFee = this.totalPackageFee;
    }
    else if (this.totalMembers > 1  || this.noofMonths > 1) {
      calPackageFee = this.totalPackageFee * this.totalMembers;
    }

    if (this.monthlyDiscount > calPackageFee) {
      this.discountExceedsFee = true;
    } else {
      this.discountExceedsFee = false;
    }

    this.compileFeeCalculationEquation();
    this.updateNextDueDatePreview();
  }
  checkRegistrationDiscount() {
    let calRegistrationPackageFee;
    if (this.totalMembers > 1) {
      calRegistrationPackageFee = this.totalRegistrationPackageFee * this.totalMembers;
    }
    else {
      calRegistrationPackageFee = this.totalRegistrationPackageFee;
    }
    if (this.registrationDiscount > calRegistrationPackageFee) {
      this.discountExceedsRegistrationFee = true;
    } else {
      this.discountExceedsRegistrationFee = false;
    }
    this.compileFeeCalculationEquation();
  }

  onTotalRegistrationFeeChange() {
    this.compileFeeCalculationEquation();
  }
  checkTrainerDiscount() {
    let calTrainerFee;
    if (this.totalMembers > 1) {
      calTrainerFee = this.totalTrainerFee * this.totalMembers;
    }
    else {
      calTrainerFee = this.totalTrainerFee;
    }
    if (this.trainerDiscount > calTrainerFee) {
      this.trainerDiscountExceeds = true;
    } else {
      this.trainerDiscountExceeds = false;
    }
    this.compileFeeCalculationEquation();
  }
  setFeeLabels() {
    if (this.packageFeeType.toLowerCase() == "per month fee") {
      this.packageFeeLabel = "Whole";
    }
    else if (this.packageFeeType.toLowerCase() == "per person fee") {
      this.packageFeeLabel = "Per Person";
    }
    else if (this.packageFeeType.toLowerCase() == "whole package fee") {
      this.packageFeeLabel = "Whole";
    }
    if (this.packageRegFeeType.toLowerCase() == "per person registration fee") {
      this.regFeeLabel = "Per Person";
    }
    else if (this.packageRegFeeType.toLowerCase() == "whole package registration fee") {
      this.regFeeLabel = "Whole";
    }
  }
  ngAfterViewInit() {
    this.totalFeePackageInput.nativeElement.focus();
    // document.getElementById("feePackageName").focus()
  }

  private getPackageDurationInput(): PackageDurationInput {
    const dt = (this.durationType || 'months').toLowerCase();
    const n = this.noofMonths || 1;
    return {
      durationType: dt,
      noOfMonths: dt === 'months' ? n : 1,
      noOfDays: dt === 'days' ? n : 0,
      noOfWeeks: dt === 'weeks' ? n : 0,
    };
  }

  private resolveBillingPeriodStart(): Date | null {
    const memberDue = this.members?.[0]?.settings?.dueDate;
    return (
      parseLocalBillingDate(memberDue) ??
      parseLocalBillingDate(this.joiningDate)
    );
  }

  /** Next due / paid-through preview (matches Add Fee billing-period logic). */
  private updateNextDueDatePreview(): void {
    const periodStart = this.resolveBillingPeriodStart();
    if (!periodStart) {
      return;
    }

    const bounds = computeBillingPeriodBounds(
      periodStart,
      this.getPackageDurationInput(),
    );

    const payAmount =
      this.totalMembers > 1
        ? (Number(this.totalPackageFee) || 0) * this.totalMembers
        : Number(this.totalPackageFee) || 0;

    const preview = resolveMonthlyFeeDueDatePreview({
      billingPeriodStart: bounds.billingPeriodStart,
      billingPeriodEnd: bounds.billingPeriodEnd,
      netPackageFee: this.fullMonthlyNetFee,
      alreadyPaid: 0,
      payAmount,
      discountAmount: Number(this.monthlyDiscount) || 0,
    });

    if (preview) {
      this.expiryDate = preview;
      this.dueDate = preview.toDateString();
    }
  }

  onPaymentModeChange(value: string) {
    this.paymentMode = value;
    const extractedValue = value.split("-")[1];
    if (Array.isArray(this.branch.payments)) {
      this.branch.payments.forEach(payment => {
        if (payment.name == extractedValue) {
          this.taxType = payment.taxSettings.taxCalculationType;
          this.taxRate = payment.taxSettings.taxRate;
        }
      });
    }
    this.compileFeeCalculationEquation();
  }
  onUploadButtonClick(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }

  fileChangeEvent(event: any): void {
    const file: File = event.target.files[0];
    this.selectedFileName = file.name;
    this.modifiedFileName = file.name + ":" + this.currentUserData.company + ":" + this.currentUserData.branch;
    const modifiedFile = new File([file], this.modifiedFileName, { type: file.type });
    this.selectedFile = modifiedFile;
  }

  uploadReceipt(formData: FormData): Observable<any> {

    return this.appServiceManager.post('branches/' + AuthService.getLoggedInBranch() + '/customers/upload/fee-receipt-only', formData).toPromise()
      .then((res: any) => {
        this.selectedFileName = res.data.feeReceiptImageUrl;
      })
      .catch(error => {
        // Handle errors if needed
      });
  }

  async addFee() {
    console.log(this.selectedFileName)
    // this.packageDiscount = 0;
    this.totalRegistrationPackageFee=this.totalRegistrationPackageFee * this.totalMembers;
    this.totalPackageFee=this.totalReceivedFee;
    if (this.noofMonths>1 && this.totalMembers ==1){
      this.monthlyDiscount= parseFloat((this.monthlyDiscount).toFixed(2));
    }
    else if (this.noofMonths==1 && this.totalMembers >1){
      this.monthlyDiscount= parseFloat((this.monthlyDiscount/this.totalMembers).toFixed(2));
      this.registrationDiscount= parseFloat((this.registrationDiscount/this.totalMembers).toFixed(2));
      this.trainerDiscount= parseFloat((this.trainerDiscount/this.totalMembers).toFixed(2));
    }
    else if(this.noofMonths>1 && this.totalMembers >1){
      this.monthlyDiscount= parseFloat((this.monthlyDiscount/this.totalMembers).toFixed(2));
      this.monthlyDiscount= parseFloat((this.monthlyDiscount).toFixed(2));
      this.registrationDiscount= parseFloat((this.registrationDiscount/this.totalMembers).toFixed(2));
      this.trainerDiscount= parseFloat((this.trainerDiscount/this.totalMembers).toFixed(2));
    }
    if (this.selectedFile) {
      const formData: FormData = new FormData();
      formData.append('feeReceiptImage', this.selectedFile, this.selectedFile.name);
      try {
        await this.uploadReceipt(formData);
        this.feeReceiptImageUrl = this.selectedFileName;
      } catch (error) { }
    }
    this.addFund.emit({
      totalPackageFee: this.totalPackageFee,
      totalReceivedFee: this.totalReceivedFee,
      totalTrainerFee: this.totalTrainerFee,
      registrationDiscount: this.registrationDiscount,
      monthlyDiscount: this.monthlyDiscount,
      trainerDiscount: this.trainerDiscount,
      feeReceiptImageUrl: this.feeReceiptImageUrl,
      paymentMode: this.paymentMode,
      totalRegistrationPackageFee: this.totalRegistrationPackageFee,
      nextDuedate: toBillingDateString(this.expiryDate),
      description: this.description
    });
  }

  registrationPayment() {
    let index = 0;
    this.onlineButtonPressed = true;
    let memberID;
    if (Array.isArray(this.onlineMembers)) {
      const onlineMembersIds = this.onlineMembers.map(member => member._id);
      console.log(onlineMembersIds);
      if (onlineMembersIds.length == 1) {
        this.selectedMemberId = this.member_id;
        memberID = this.selectedMemberId;
      }
      else {
        memberID = this.selectedMemberId._id;
      }
      const requestBody = {
        member_id: memberID,
        onlinePaymentNoOfMonths: this.noofMonths,
        onlinePaymentNoOfMembers: this.totalMembers,
        onlinePaymentMonthlyAmount: this.totalPackageFee,
        onlinePaymentMonthlyDiscount: this.monthlyDiscount,
        onlinePaymentMonthlyTax: this.taxOnMonthlyFee,
        onlinePaymentRegistrationAmount: this.totalRegistrationPackageFee,
        onlinePaymentRegistrationDiscount: this.registrationDiscount,
        onlinePaymentRegistrationTax: this.taxOnRegistration,
        onlinePaymentTrainerAmount: this.totalTrainerFee,
        onlinePaymentTrainerDiscount: this.trainerDiscount,
        onlinePaymentTrainerTax: this.taxOnTrainerFee,
        onlinePaymentTaxType: this.taxType,
        onlinePaymentTaxRate: this.taxRate,
        onlineMembers: onlineMembersIds
      };

      this.appServiceManager.post('customers/addRegistrationPayment', requestBody).subscribe(
        (res) => {
          if (res) {
            // Handle the response here if needed.
            // Example: this.customer = res;
          } else {
            this.messageService.clear();
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Something Went Wrong',
            });
          }
        },
        (error) => {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: error,
          });
        }
      );
      if (onlineMembersIds.length > 1) {
        for (let i = 0; i < onlineMembersIds.length; i++) {
          if (onlineMembersIds[i] == this.selectedMemberId._id) {
            index = i;
            break;
          }
        }
      }
      this.openWhatsApp(this.onlineMembers[index]);
      this.dialogClose();
    }
  }


  openWhatsApp(member): string {

    let reciever = member.contactDetail.contact;
    if (member.contactDetail.contact) {
      reciever = "+92" + reciever.slice(-10);

      let date = new Date(member.settings.dueDate);
      let month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
      let monthName = date.toLocaleString('en-US', { month: 'long' }); // Get the month name
      let year = date.getFullYear();

      let sessionData = localStorage.getItem('currentCompany');
      let parsedData = JSON.parse(sessionData);
      let name = parsedData.name;
      let msg = this.config.FeeReminderMessage;
      if (this.currentUserData.branch == "651a591aae5ff029ba201bd6") {
        msg = this.config.jackedfeesMessage;
      }
      msg = msg.replace("{0}", member.name);
      msg = msg.replace("{1}", member._id);
      msg = msg.replace("{2}", month.toString());
      msg = msg.split("{3}").join(year.toString());
      msg = msg.replace("{4}", member.company);
      msg = msg.replace("{5}", member.branch);
      msg = msg.replace("{6}", monthName);
      msg = msg.replace("{7}", name);
      msg = msg.replace("{8}", "true");
      const paymentToken = AppUtils.encodePublicQueryToken({
        memberid: member._id,
        month: month,
        year: year,
        company: member.company,
        branch: member.branch,
        isRegistration: true,
      });
      msg = msg.replace("{10}", paymentToken);
      if (this.whatsAppCommunityLink) {
        msg = msg.replace("{9}", this.whatsAppCommunityLinkMessage);
      } else {
        msg = msg.replace("{9}", "");
      }


      const message = encodeURIComponent(msg);

      if (/^\+92\d{10}$/.test(reciever)) {
        const link = document.createElement('a');
        link.href = `https://wa.me/${reciever}?text=${message}`;
        link.target = '_blank';
        link.click();
        return '';
      } else {
        // Show error message here
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: 'Invalid phone number',
        });
        return '';
      }
    } else {
      // Show error message here
      this.messageService.clear();
      this.messageService.add({
        severity: "error",
        summary: "Error Message",
        detail: 'This user does not have a phone number',
      });
      return '';
    }
  }

  onTotalPackageFeeChange() {
    if (this.totalMembers > 1) {
      this.totalReceivedFee =
        (Number(this.totalPackageFee) || 0) * this.totalMembers;
    } else {
      this.totalReceivedFee = Number(this.totalPackageFee) || 0;
    }
    this.compileFeeCalculationEquation();
    this.updateNextDueDatePreview();
  }
  dialogClose() {
    this.closeFeeCollectionDialog.emit();
  }

  hotkeys($event) {
    var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
    var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
    var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
    if ($event.keyCode == 13 && confirmationBoxButtonExistLength > 0) {
      if (document.activeElement.tagName === "BODY") {
        confirmationBoxButtonExist[0].focus();
      }
      else {
        if (document.activeElement === confirmationBoxButtonExist[0]) {
          confirmationBoxButtonExist[0].focus();
        }
        else if (document.activeElement === confirmationBoxButtonExist[1]) {
          confirmationBoxButtonExist[1].focus();
        }
        else {
          confirmationBoxButtonExist[1].focus();
        }
      }
    } else if ($event.keyCode == 13) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId)
      if (ele == null && nextId == "trainerFeePackage") {
        document.getElementById("feeSaveButton").focus();
        this.currentStep = 4;
      } else if (ele.disabled && nextId == "feeSaveButton") {
        document.getElementById("totalFeePackage").focus();
        this.currentStep = 0;
      } else {
        ele.focus();
        this.currentStep = nextStep;
      }
    }
  }

  hotClicky($event) {
    let currentClickLocation = $event.target.id;
    let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
    if (indexOfClickField !== -1) {
      this.currentStep = indexOfClickField;
    }
  }

}
